import { List, ListItem } from "@mui/material";
import { memo, useCallback } from "react";

import DatePickerFilter from "../../../../../../../modules/CaseList/Filters/FiltersList/components/DatePickerFilter";
import DateRange from "../../../../../../../modules/CaseList/Filters/FiltersList/components/DateRange";
import MultiSelectSearch from "../../../../../../../modules/CaseList/Filters/FiltersList/components/MultiSelectSearch";
import RangeSlider from "../../../../../../../modules/CaseList/Filters/FiltersList/components/RangeSlider";
import SearchOptionGroup from "../../../../../../../modules/CaseList/Filters/FiltersList/components/SearchOptionGroup";
import SingleSelect from "../../../../../../../modules/CaseList/Filters/FiltersList/components/SingleSelect";

const DrawerFiltersListLocal = ({
  datePickerSlotProps,
  filterState = [],
  updateFilter,
  bulkUpdateFilters,
}) => {
  const renderFilterUI = useCallback(
    (element) => {
      const currentFilterState = filterState.find((f) => f.fieldName === element.fieldName);

      if (!currentFilterState) {
        return null;
      }

      switch (element.filterType) {
        case "RangeSlider":
          return (
            <RangeSlider
              bulkUpdateFilters={bulkUpdateFilters}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              maxValue={currentFilterState.currentValue?.__lte}
              minValue={currentFilterState.currentValue?.__gte}
              title={currentFilterState.title}
            />
          );

        case "MultiSelectSearch":
          return (
            <MultiSelectSearch
              apiUrl={currentFilterState.apiUrl}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              nameKey={currentFilterState.nameKey}
              orderingVal={currentFilterState.orderingVal}
              options={currentFilterState.options}
              searchTitle={currentFilterState.searchTitle}
              selectedItems={currentFilterState.currentValue || []}
              title={currentFilterState.title}
              updateFilter={updateFilter}
              valueKey={currentFilterState.valueKey}
            />
          );

        case "SingleSelect":
          return (
            <SingleSelect
              apiUrl={currentFilterState.apiUrl}
              currentValue={currentFilterState.currentValue}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              nameKey={currentFilterState.nameKey}
              orderingVal={currentFilterState.orderingVal}
              title={currentFilterState.title}
              updateFilter={updateFilter}
              valueKey={currentFilterState.valueKey}
              defaultValue={currentFilterState?.defaultValue}
              fetchFromAPI={currentFilterState?.fetchFromAPI}
              staticData={currentFilterState?.staticData}
              hideClearBtn={currentFilterState?.hideClearBtn}
            />
          );

        case "SearchOptionGroup":
          return (
            <SearchOptionGroup
              currentValue={currentFilterState.currentValue}
              customFalseLabel={currentFilterState.customFalseLabel}
              customTrueLabel={currentFilterState.customTrueLabel}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              title={currentFilterState.title}
              updateFilter={updateFilter}
            />
          );

        case "DatePicker":
          return (
            <DatePickerFilter
              currentValue={currentFilterState.currentValue}
              datePickerSlotProps={datePickerSlotProps}
              fieldName={currentFilterState.fieldName}
              title={currentFilterState.title}
              updateFilter={updateFilter}
            />
          );

        case "DateRange":
          return (
            <DateRange
              dateFrom={currentFilterState.currentValue?.__gte}
              datePickerSlotProps={datePickerSlotProps}
              dateTo={currentFilterState.currentValue?.__lte}
              fieldName={currentFilterState.fieldName}
              isActive={currentFilterState.activeChip.isActive}
              title={currentFilterState.title}
              updateFilter={updateFilter}
            />
          );

        default:
          return null;
      }
    },
    [datePickerSlotProps, filterState, updateFilter, bulkUpdateFilters]
  );

  const renderFilterList = useCallback(
    () => (
      <List>
        {filterState.map((filterConfig) => (
          <ListItem key={filterConfig.fieldName}>{renderFilterUI(filterConfig)}</ListItem>
        ))}
      </List>
    ),
    [filterState, renderFilterUI]
  );

  return <div className="h-full overflow-y-auto">{renderFilterList()}</div>;
};

export default memo(DrawerFiltersListLocal);
